// The account portal (sculpt-account, PLAN-accounts.md §10): where signup, password reset, the organization, usage
// and billing live. Signup runs inside the Office dialog (services/office/dialog.ts); the rest opens in the system
// browser, signed in (`openPortal`). Always https: an Office dialog refuses to navigate to a plain-http origin, so
// the dev portal runs with `HTTPS=1 npm start` (the Office dev certificate) on 5174.
import { apiService } from './ApiService';
import { openInBrowser } from './office/browser';

const DEFAULT_PORTAL_URL = 'https://localhost:5174';

function base(): string {
  return (import.meta.env.VITE_PORTAL_URL ?? DEFAULT_PORTAL_URL).replace(/\/$/, '');
}

export function portalUrl(path = '/'): string {
  return `${base()}${path.startsWith('/') ? path : `/${path}`}`;
}

/** The portal's `/auth/link` landing: it trades the single-use code (sculpt-api `POST /token/portal-link`, two
 *  minutes) for its own session and goes to `next`. In the fragment, so the code never reaches a server log. */
export function portalLinkUrl(code: string, path = '/'): string {
  return `${base()}/auth/link#${new URLSearchParams({ code, next: path.startsWith('/') ? path : `/${path}` }).toString()}`;
}

/** Opens a portal page in the browser, signed in as the pane's user. Without a code (API unreachable) the plain
 *  page opens and the portal asks to sign in. */
export async function openPortal(path = '/'): Promise<void> {
  let url = portalUrl(path);
  try {
    url = portalLinkUrl((await apiService.portalLink()).code, path);
  } catch (err) {
    console.warn('[agent-v2] portal link unavailable, opening the portal unsigned', err);
  }
  openInBrowser(url);
}
